module.exports = __webpack_public_path__ + "img/svg6.1ddc7f22.svg";